<template>
    <div class="ui container">
        <vuetable ref="vuetable"
            :http-fetch="fetchData"
            :api-mode="true"
            :api-url="apiUrl()"
            :fields="listFields"
            pagination-path="pagination"
            data-path=""
            :http-options="httpOptions()"
            @vuetable:pagination-data="onPaginationData">
            <template slot="width" scope="props">
            	{{props.rowData.width}}{{props.rowData.unit}}
            </template>
            <template slot="height" scope="props">
            	{{props.rowData.height}}{{props.rowData.unit}}
            </template>
            <template slot="print" scope="props">
            	<button v-if="guest_id" class="ui button" @click="print(props.rowData.event_id, props.rowData.id, guest_id)">
            		<i class="fa fa-edit"></i> Print
            	</button>
            </template>
        </vuetable>
        <vuetable-pagination
            ref="pagination" @vuetable-pagination:change-page="onChangePage">
        </vuetable-pagination>
    </div>
</template>

<style>
.pagination a.item {
    padding: 10px;
}

.pagination a.item.large {
    font-weight: bolder
}
</style>

<script>
// import Vue from "vue";
import {Vuetable, VuetablePagination} from "vuetable-2";
import axios from "axios";

const RANGE_RGX = /^(?:items\s)?(\d+)-(\d+)\/(\d+)$/;

export default {
    name: "accountsList",
    components: {
        Vuetable,
        VuetablePagination
    },
    props: [
    	"event_id",
    	"guest_id"
    ],
    data: () => {
        return {
            fields: [
                {
                    name: "__sequence",
                    title: "#",
                    titleClass: "center aligned",
                    dataClass: "right aligned"
                },
                {
                    name: "__slot:idslot",
                    title: "id"
                },
                {
                    name: "__slot:print",
                    title: "Actions"
                },
                {
                    name: "name",
                    title: "Name"
                },
                {
                    name: "format",
                    title: "Format"
                },
                {
                    name: "__slot:width",
                    title: "width"
                },
                {
                    name: "__slot:height",
                    title: "height"
                }
            ],
            resources: {
                events: "/events",
                guests: "/guests",
                badges: "/badges"
            },
            page: 1,
            perPage: 10,
        };
    },
    computed: {
        listFields() {
            return this.$data.fields;
        }
    },
    methods: {
        account(accountId) {
            this.$router.push({name: "accountDetails", params: {account_id: accountId}});
        },
        fetchData(resource, options) {
            if (options && options.hasOwnProperty("params")) {
                options.headers["Range"] = "items=" + (options.params.page - 1) * options.params.per_page + "-";
                options.headers["Range"] += (options.params.page - 1) * options.params.per_page + options.params.per_page - 1;
            }

            let currentPage = options.params.page;
            let perPage = options.params.per_page;

            delete options.params.page;
            delete options.params.per_page;

            if (!options.params.sort) {
                delete options.params.sort;
            }

            return axios
                .get(resource, options)
                .then(response => {
                    let m = RANGE_RGX[Symbol.match](
                        response.headers["content-range"]
                    );

                    const from = parseInt(m[1]);
                    const to = parseInt(m[2]);
                    const total = parseInt(m[3]);

					if (!response.data) {
                    	response.data = {};
                    }
                    response.data.pagination = {
                        total: total,
                        per_page: perPage,
                        current_page: currentPage,
                        last_page: Math.ceil(total / perPage),
                        from: from,
                        to: to
                    };

                    return response;
                })
                .catch(response => {
                    console.log(response);
                });
        },
		apiUrl() {
			return this.$store.getters.apiBase + this.$data.resources.events + "/" + this.$props["event_id"] + this.$data.resources.badges;
		},
        httpOptions() {
            const _headers = {
                "Content-Type": "application/json",
                Authorization: this.$store.getters.accessToken,
                account_id: this.$store.getters.accountId
            };

            return {headers: _headers};
        },
        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        print(idEvento, idBadge, idPersona) {
        	axios.get(`${this.$store.getters.apiBase}${this.$data.resources.events}/${idEvento}
${this.$data.resources.guests}/${idPersona}
${this.$data.resources.badges}/${idBadge}`, {
				headers: {
					Accept: "application/pdf",
					Authorization: this.$store.getters.accessToken,
                	account_id: this.$store.getters.accountId
                },
				responseType: "arraybuffer"
			}).then(response => {
				let blob = new Blob([response.data], { type: "application/pdf" } ),
					url = window.URL.createObjectURL(blob)
			
				window.open(url); // Mostly the same, I was just experimenting with different approaches, tried link.click, iframe and other solutions
			},
				error => {
				console.log("error", error);
				console.log("res", error.response);
			});
        }
    },
    watch: {
    	"$route": "fetchData"
    },
    created() {
    	
    }
};
</script>